export const NY_TIMEZONE = 'America/New_York';

export const parseClassDateParts = (dateStr) => {
    if (!dateStr) return null;
    const datePart = String(dateStr).split('T')[0];
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(datePart);
    if (!match) return null;

    return {
        year: Number(match[1]),
        month: Number(match[2]),
        day: Number(match[3]),
    };
};

export const formatClassDate = (dateStr, language = 'en') => {
    const parts = parseClassDateParts(dateStr);
    if (!parts) return '';

    const date = new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 12, 0, 0));
    const locale = language.startsWith('es') ? 'es-US' : 'en-US';

    return new Intl.DateTimeFormat(locale, {
        timeZone: NY_TIMEZONE,
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    }).format(date);
};

export const getNyTimezoneAbbreviation = (dateStr) => {
    const parts = parseClassDateParts(dateStr);
    const anchor = parts
        ? new Date(Date.UTC(parts.year, parts.month - 1, parts.day, 17, 0, 0))
        : new Date();

    const tzPart = new Intl.DateTimeFormat('en-US', {
        timeZone: NY_TIMEZONE,
        timeZoneName: 'short',
    })
        .formatToParts(anchor)
        .find((part) => part.type === 'timeZoneName');

    return tzPart?.value || 'ET';
};

export const formatClassTime = (timeStr, language = 'en', referenceDateStr) => {
    if (!timeStr) return '';

    const segments = String(timeStr).split(':');
    const hour = Number(segments[0]);
    const minute = Number(segments[1]);
    if (Number.isNaN(hour) || Number.isNaN(minute)) return '';

    const locale = language.startsWith('es') ? 'es-US' : 'en-US';
    const wallClock = new Date(2000, 0, 1, hour, minute);
    const formatted = new Intl.DateTimeFormat(locale, {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    }).format(wallClock);

    return `${formatted} ${getNyTimezoneAbbreviation(referenceDateStr)}`;
};

export const formatClassTimeRange = (startTime, endTime, language = 'en', referenceDateStr) => {
    const start = formatClassTime(startTime, language, referenceDateStr);
    const end = formatClassTime(endTime, language, referenceDateStr);

    if (!start && !end) return '';
    if (!start) return end;
    if (!end) return start;

    return `${start} – ${end}`;
};
